export interface ShortcutDefinition {
  keys: string;
  description: string;
  category: 'navigation' | 'modals' | 'sectors' | 'demands' | 'general' | 'demand-view' | 'toolbar';
  platform?: 'windows' | 'mac' | 'all';
}

export interface ShortcutCategory {
  name: string;
  description: string;
  shortcuts: ShortcutDefinition[];
}

/**
 * Platform detection utility
 */
export const getPlatform = (): 'windows' | 'mac' | 'other' => {
  if (typeof window === 'undefined') return 'other';
  
  const userAgent = window.navigator.userAgent.toLowerCase();
  if (userAgent.includes('mac')) return 'mac';
  if (userAgent.includes('win')) return 'windows';
  return 'other';
};

/**
 * Get the appropriate modifier key for the current platform
 */
export const getModifierKey = (): string => {
  const platform = getPlatform();
  return platform === 'mac' ? 'cmd' : 'ctrl';
};

/**
 * All keyboard shortcuts configuration
 */
export const SHORTCUTS: ShortcutCategory[] = [
  {
    name: 'Navegação',
    description: 'Atalhos para navegar entre páginas',
    shortcuts: [
      // {
      //   keys: 'h',
      //   description: 'Ir para o Dashboard',
      //   category: 'navigation',
      //   platform: 'all'
      // },
      // {
      //   keys: 'd',
      //   description: 'Ir para Demandas',
      //   category: 'navigation',
      //   platform: 'all'
      // },
      // {
      //   keys: 'c',
      //   description: 'Ir para Colaboradores',
      //   category: 'navigation',
      //   platform: 'all'
      // },
      // {
      //   keys: 'n',
      //   description: 'Ir para Notificações',
      //   category: 'navigation',
      //   platform: 'all'
      // },
      // {
      //   keys: 'ctrl+alt+n',
      //   description: 'Criar Nova Demanda',
      //   category: 'navigation',
      //   platform: 'all'
      // },
      // {
      //   keys: 'ctrl+d l',
      //   description: 'Ver Todas as Demandas (Lista)',
      //   category: 'navigation',
      //   platform: 'all'
      // },
      // {
      //   keys: 'ctrl+d r',
      //   description: 'Ver Demandas Recebidas',
      //   category: 'navigation',
      //   platform: 'all'
      // },
      // {
      //   keys: 'ctrl+d e',
      //   description: 'Ver Demandas Enviadas',
      //   category: 'navigation',
      //   platform: 'all'
      // },
      // {
      //   keys: 'ctrl+d a',
      //   description: 'Ver Todas as Demandas (All)',
      //   category: 'navigation',
      //   platform: 'all'
      // },
      // {
      //   keys: 'ctrl+g p',
      //   description: 'Ir para Processos',
      //   category: 'navigation',
      //   platform: 'all'
      // },
      // {
      //   keys: 'ctrl+g s',
      //   description: 'Ir para Setores',
      //   category: 'navigation',
      //   platform: 'all'
      // },
      // {
      //   keys: 'ctrl+g e',
      //   description: 'Ir para Equipes',
      //   category: 'navigation',
      //   platform: 'all'
      // },
      // {
      //   keys: 'ctrl+g a',
      //   description: 'Ir para Autorizadores',
      //   category: 'navigation',
      //   platform: 'all'
      // }
    ]
  },
  {
    name: 'Setores',
    description: 'Atalhos para alternar entre setores',
    shortcuts: [
      // {
      //   keys: 'alt+1',
      //   description: 'Alternar para Setor 1',
      //   category: 'sectors',
      //   platform: 'all'
      // },
      // {
      //   keys: 'alt+2',
      //   description: 'Alternar para Setor 2',
      //   category: 'sectors',
      //   platform: 'all'
      // },
      // {
      //   keys: 'alt+3',
      //   description: 'Alternar para Setor 3',
      //   category: 'sectors',
      //   platform: 'all'
      // },
      // {
      //   keys: 'alt+4',
      //   description: 'Alternar para Setor 4',
      //   category: 'sectors',
      //   platform: 'all'
      // },
      // {
      //   keys: 'alt+5',
      //   description: 'Alternar para Setor 5',
      //   category: 'sectors',
      //   platform: 'all'
      // },
      // {
      //   keys: 'alt+6',
      //   description: 'Alternar para Setor 6',
      //   category: 'sectors',
      //   platform: 'all'
      // },
      // {
      //   keys: 'alt+7',
      //   description: 'Alternar para Setor 7',
      //   category: 'sectors',
      //   platform: 'all'
      // },
      // {
      //   keys: 'alt+8',
      //   description: 'Alternar para Setor 8',
      //   category: 'sectors',
      //   platform: 'all'
      // },
      // {
      //   keys: 'alt+9',
      //   description: 'Alternar para Setor 9',
      //   category: 'sectors',
      //   platform: 'all'
      // }
    ]
  },
  {
    name: 'Demandas',
    description: 'Atalhos para criar e editar demandas',
    shortcuts: [
      // {
      //   keys: 'ctrl+enter',
      //   description: 'Salvar Demanda',
      //   category: 'demands',
      //   platform: 'all'
      // },
      // {
      //   keys: 'ctrl+enter',
      //   description: 'Enviar/Submeter Demanda',
      //   category: 'demands',
      //   platform: 'all'
      // },
      // {
      //   keys: 'escape',
      //   description: 'Cancelar/Voltar',
      //   category: 'demands',
      //   platform: 'all'
      // }
    ]
  },
  {
    name: 'Modais',
    description: 'Atalhos para controlar modais',
    shortcuts: [
      // {
      //   keys: 'escape',
      //   description: 'Fechar Modal',
      //   category: 'modals',
      //   platform: 'all'
      // },
      // {
      //   keys: 'ctrl+m',
      //   description: 'Minimizar Modal',
      //   category: 'modals',
      //   platform: 'all'
      // }
    ]
  },
  {
    name: 'Visualização de Demanda',
    description: 'Atalhos para a tela de detalhes da demanda',
    shortcuts: [
      // {
      //   keys: 's',
      //   description: 'Abrir/Fechar Sidebar',
      //   category: 'demand-view',
      //   platform: 'all'
      // },
      // {
      //   keys: 'p',
      //   description: 'Abrir/Fechar Informações (Pessoas e Setores)',
      //   category: 'demand-view',
      //   platform: 'all'
      // },
      // {
      //   keys: 'ctrl+b',
      //   description: 'Abrir Toolbar de Ações',
      //   category: 'demand-view',
      //   platform: 'all'
      // }
    ]
  },
  {
    name: 'Toolbar de Ações (Ctrl+B + tecla)',
    description: 'Atalhos para ações da toolbar (pressione Ctrl+B primeiro)',
    shortcuts: [
      // {
      //   keys: 'ctrl+b p',
      //   description: 'Puxar Demanda para Mim',
      //   category: 'toolbar',
      //   platform: 'all'
      // },
      // {
      //   keys: 'ctrl+b e',
      //   description: 'Editar Demanda',
      //   category: 'toolbar',
      //   platform: 'all'
      // },
      // {
      //   keys: 'ctrl+b a',
      //   description: 'Atribuir Demanda',
      //   category: 'toolbar',
      //   platform: 'all'
      // },
      // {
      //   keys: 'ctrl+b s',
      //   description: 'Solucionar Demanda',
      //   category: 'toolbar',
      //   platform: 'all'
      // },
      // {
      //   keys: 'ctrl+b c',
      //   description: 'Aceitar Demanda',
      //   category: 'toolbar',
      //   platform: 'all'
      // },
      // {
      //   keys: 'ctrl+b u',
      //   description: 'Desfazer Entrega',
      //   category: 'toolbar',
      //   platform: 'all'
      // },
      // {
      //   keys: 'ctrl+b f',
      //   description: 'Aceitar Entrega (Finalizar)',
      //   category: 'toolbar',
      //   platform: 'all'
      // },
      // {
      //   keys: 'ctrl+b d',
      //   description: 'Devolver Demanda',
      //   category: 'toolbar',
      //   platform: 'all'
      // },
      // {
      //   keys: 'ctrl+b r',
      //   description: 'Recusar Demanda',
      //   category: 'toolbar',
      //   platform: 'all'
      // },
      // {
      //   keys: 'ctrl+b x',
      //   description: 'Excluir Demanda',
      //   category: 'toolbar',
      //   platform: 'all'
      // },
      // {
      //   keys: 'ctrl+b o',
      //   description: 'Adicionar Observadores',
      //   category: 'toolbar',
      //   platform: 'all'
      // },
      // {
      //   keys: 'ctrl+b w',
      //   description: 'Marcar como Demanda Errada',
      //   category: 'toolbar',
      //   platform: 'all'
      // },
      // {
      //   keys: 'ctrl+b n',
      //   description: 'Reenviar Demanda',
      //   category: 'toolbar',
      //   platform: 'all'
      // },
      // {
      //   keys: 'ctrl+b m',
      //   description: 'Comentar na Demanda',
      //   category: 'toolbar',
      //   platform: 'all'
      // },
      // {
      //   keys: 'ctrl+b t',
      //   description: 'Anexar Arquivos',
      //   category: 'toolbar',
      //   platform: 'all'
      // },
      // {
      //   keys: 'ctrl+b l',
      //   description: 'Criar Demanda Relacionada',
      //   category: 'toolbar',
      //   platform: 'all'
      // },
      // {
      //   keys: 'ctrl+b y',
      //   description: 'Aprovar (Autorização)',
      //   category: 'toolbar',
      //   platform: 'all'
      // },
      // {
      //   keys: 'ctrl+b z',
      //   description: 'Reprovar (Autorização)',
      //   category: 'toolbar',
      //   platform: 'all'
      // }
    ]
  },
  {
    name: 'Geral',
    description: 'Atalhos gerais do sistema',
    shortcuts: [
      // {
      //   keys: 'ctrl+h',
      //   description: 'Mostrar Atalhos de Teclado',
      //   category: 'general',
      //   platform: 'all'
      // },
      // {
      //   keys: 'f1',
      //   description: 'Mostrar Atalhos de Teclado',
      //   category: 'general',
      //   platform: 'all'
      // },
      // {
      //   keys: 'tab',
      //   description: 'Navegar entre elementos',
      //   category: 'general',
      //   platform: 'all'
      // }
    ]
  }
];

/**
 * Get shortcuts filtered by platform
 */
export const getShortcutsForPlatform = (): ShortcutCategory[] => {
  const currentPlatform = getPlatform();
  
  return SHORTCUTS.map(category => ({
    ...category,
    shortcuts: category.shortcuts.filter(shortcut => 
      !shortcut.platform || 
      shortcut.platform === 'all' || 
      shortcut.platform === currentPlatform
    )
  })).filter(category => category.shortcuts.length > 0);
};

/**
 * Search shortcuts by description or keys
 */
export const searchShortcuts = (query: string): ShortcutCategory[] => {
  const lowerQuery = query.toLowerCase();
  
  return SHORTCUTS.map(category => ({
    ...category,
    shortcuts: category.shortcuts.filter(shortcut => 
      shortcut.description.toLowerCase().includes(lowerQuery) ||
      shortcut.keys.toLowerCase().includes(lowerQuery)
    )
  })).filter(category => category.shortcuts.length > 0);
};
